import CodeCanyonItemCard from './codeCanyonItemCard'

export default CodeCanyonItemCard
